import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCanvas } from 'utils';
import { ActionButtons, ButtonContainer, ActionButton } from './styles';
import { ResetCameraOutlined } from 'components/icons/ResetCameraOutlined';
import { ScreenshotOutlined } from 'components/icons/ScreenshotOutlined';
import { ShadowsEnabledOutlined } from 'components/icons/ShadowsEnabledOutlined';
import { ShadowsDisabledOutlined } from 'components/icons/ShadowsDisabledOutlined';
import { withTheme } from 'styled-components';
import constants from 'constants';

const { CANVAS_UPDATE_TYPES, CANVAS_UPDATE_METHODS, RATIOS } = constants;

const ActionArea = withTheme(props => {
  const { theme, guidURL } = props;

  const dispatch = useDispatch();
  const appStore = useSelector(state => state.app);
  const canvasStore = useSelector(state => state.canvas);
  const serializedData = useMemo(() => canvasStore.serializedData, [ canvasStore ]);
  const viewportShadows = serializedData?.metadata.viewportShadows;
  const selectedRatio = serializedData?.metadata.selectedRatio;
  const selectedTheme = appStore.theme;
  const white = theme.colors[selectedTheme].white;

  const updateArgs = type => ({
    dispatch,
    type,
    method: CANVAS_UPDATE_METHODS.UPDATE,
  });

  return (
    <>
      {guidURL && (
        <ActionButtons>
          <ButtonContainer>
            <ActionButton
              theme={theme}
              $selectedTheme={selectedTheme}
              onClick={() => {
                const type = CANVAS_UPDATE_TYPES.CAMERA;
                const inboundData = { resetCamera: true };
                updateCanvas(updateArgs(type), inboundData);
              }}
            >
              <ResetCameraOutlined width={24} color={white} />
            </ActionButton>

            <ActionButton
              theme={theme}
              $selectedTheme={selectedTheme}
              onClick={() => {
                const type = CANVAS_UPDATE_TYPES.CAMERA;
                const inboundData = {
                  takeScreenshot: true,
                  aspectRatio: selectedRatio.value || RATIOS.broadcast.value,
                };

                updateCanvas(updateArgs(type), inboundData);
              }}
            >
              <ScreenshotOutlined width={24} color={white} />
            </ActionButton>

            <ActionButton
              theme={theme}
              $selectedTheme={selectedTheme}
              onClick={() => {
                const type = CANVAS_UPDATE_TYPES.VIEWPORT;
                const inboundData = { shadows: !viewportShadows };
                updateCanvas(updateArgs(type), inboundData);
              }}
            >
              {viewportShadows
                ? <ShadowsDisabledOutlined width={24} color={white} />
                : <ShadowsEnabledOutlined width={24} color={white} />
              }
            </ActionButton>
          </ButtonContainer>
        </ActionButtons>
      )}
    </>
  );
});

export { ActionArea };

